import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

import { MedPopupService } from "../../../services/med-popup.service";
import { MedHostDirective } from "../../../directives/med-host.directive";

@Component({
  selector: "med-popup-content",
  templateUrl: "./med-popup-content.component.html",
})
export class MedPopupContentComponent implements AfterViewInit {
  constructor(public medPopup: MedPopupService<any, any>) {}

  @ViewChild(MedHostDirective) hostTemplate!: MedHostDirective;
  @ViewChild("popupContentRef") popupContentRef!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    this.medPopup.popupContentEl = this.popupContentRef.nativeElement;
    this.medPopup.host = this.hostTemplate;
  }
}
